// Added by Sejune Oh on 2020-02-18
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { FC } from 'react';
import {
    FormHelperText as MaterialFormHelperText,
    FormHelperTextProps as MaterialFormHelperTextProps
} from '@material-ui/core'

interface FormHelperTextBaseProps { }
export type FormHelperTextProps = Partial<MaterialFormHelperTextProps> & FormHelperTextBaseProps

export const FormHelperText: FC<FormHelperTextProps> = ({ ...props }) => {
    return <MaterialFormHelperText  {...props} />
}
